export function groupByField<TItem, TKey extends keyof TItem>(items: TItem[], groupBy: TKey): Map<TItem[TKey], TItem> {
  return items.reduce<Map<TItem[TKey], TItem>>((map, item) => {
    return map.set(item[groupBy], item);
  }, new Map());
}
